module.exports = __webpack_public_path__ + "static/img/webapps-02.5e8c6391.jpg";